module.exports = __webpack_public_path__ + "img/icon_xfzt.e8d77550.png";